import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { defaultValues } from './model';

import { connectedAppFormSchema } from '../schemas';

export function useFormDefinition() {
  return useForm({
    resolver: zodResolver(connectedAppFormSchema),
    defaultValues,
    shouldFocusError: true,
  });
}
